<template>
  <v-container fluid class="pa-0">
    <v-row class="pt-3">
      <v-col :cols="isSelect ? 7 : 9" class="pl-6">
        <span class="table-card-title pl-0">Produtos</span> <br />
        <p class="subtitle pt-1" style="word-break: break-word">
          Alterações realizadas aqui serão aplicadas em todas as partes da Mercafacil que utilizam produtos, como a Gestão de ofertas e o seu Aplicativo, por
          exemplo. Para aplicar ofertas no seu frente de caixa os produtos devem existir previamente no seu ERP.
        </p>
      </v-col>
      <v-col :cols="isSelect ? 5 : 3">
        <v-row no-gutters justify="end">
          <v-col class="mb-1" cols="auto">
            <mf-tooltip variant="secondary" top max-width="250">
              <template v-slot:activator>
                <mf-icon>info</mf-icon>
              </template>
              <span>
                Insira a pesquisa entre aspas para buscar por correspondência exata.
                <br />
                <b>Exemplo: "55"</b>
              </span>
            </mf-tooltip>
          </v-col>
        </v-row>
        <mf-search v-model="search" placeholder="Busca por EAN, nome ou SKU" hide-details data-cy="productSearchBar" @input="filterBySearch" />
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :loading="paginationLoading"
          :server-items-length="maxRecords"
          :items="products"
          :options.sync="options"
          :footer-props="{ itemsPerPageOptions: [15, 50, 100] }"
          :single-select="true"
          item-key="id"
          :show-select="isSelect"
          :height="height"
        >
          <template v-slot:item="{ item, index }">
            <tr @click="clickAction(item, index)">
              <td v-if="isSelect">
                <v-checkbox v-model="item.isSelected" />
              </td>
              <td>
                <v-img v-if="item.images && item.images.length && item.images[0].url" :src="showMainImage(item.images)" contain height="40px" class="td-img" />
                <mf-icon v-else color="cinza-0" class="icon-align"> image </mf-icon>
              </td>
              <td>
                <div v-if="item.manuallyEdited" :key="`${index}-1`" class="d-flex align-center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div style="width: 24px" class="mr-2" v-bind="attrs" v-on="on">
                        <mf-icon color="#FF8A00" fill>border_color</mf-icon>
                      </div>
                    </template>
                    <span>Editado</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.name" max-width="350" top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="limitText" v-bind="attrs" v-on="on">{{ item.name }}</span>
                    </template>
                    <span>{{ item.name }}</span>
                  </v-tooltip>
                  <span v-else>-</span>
                </div>
                <div v-else-if="item.catalogId && item.catalogId.length > 0 && $getUseCatalogFlag()" :key="`${index}-2`" class="d-flex align-center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div style="width: 24px" class="mr-2" v-bind="attrs" v-on="on">
                        <mf-icon color="verde-l10" fill class="mr-2" v-on="on">verified</mf-icon>
                      </div>
                    </template>
                    <span>Mercafacil</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.name" max-width="350" top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="limitText" v-bind="attrs" v-on="on">{{ item.name }}</span>
                    </template>
                    <span>{{ item.name }}</span>
                  </v-tooltip>
                  <span v-else>-</span>
                </div>
                <div v-else :key="`${index}-3`" class="d-flex align-center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div style="width: 24px" class="mr-2" v-bind="attrs" v-on="on">
                        <mf-icon color="marca-0-l40" fill class="mr-2" v-on="on">store</mf-icon>
                      </div>
                    </template>
                    <span>Integração</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.name" max-width="350" top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="limitText" v-bind="attrs" v-on="on">{{ item.name }}</span>
                    </template>
                    <span>{{ item.name }}</span>
                  </v-tooltip>
                  <span v-else>-</span>
                </div>
              </td>
              <td class="align-center">
                <mf-tooltip variant="secondary" top max-width="250">
                  <template v-slot:activator>
                    {{ showMainEan(item.eans) }}
                  </template>
                  <v-row no-gutters>
                    <v-col v-for="i in item.eans" :key="i" cols="12">
                      <span class="limitText">
                        {{ i.ean }}
                      </span>
                      <div class="linha"></div>
                    </v-col>
                  </v-row>
                </mf-tooltip>
              </td>
              <td
                v-if="($getLoggedUser().has_club && !$getIsEcommerce()) || ($getLoggedUser().has_club && $getIsEcommerce()) || $getLoggedUser().has_mercapromo"
                class="align-center"
              >
                <span v-if="item.legacySku">
                  {{ item.legacySku }}
                </span>
                <mf-tooltip v-else variant="secondary" top max-width="250">
                  <template v-slot:activator>
                    <mf-icon color="#ffcc00">report</mf-icon>
                  </template>
                  <span> Produtos sem SKU cadastrado não aparecerão na gestão de ofertas, impossibilitando que sejam criadas ofertas para eles. </span>
                </mf-tooltip>
              </td>
              <td>{{ item.department ? item.department.name : '-' }}</td>
              <td v-if="isPhygital">{{ item.cbm || item.ecommerce ? getLabelPlataform(item) : '-' }}</td>
              <td>{{ item.createdAt ? formatDate(item.createdAt) : '-' }}</td>
              <td>{{ item.updatedAt ? formatDate(item.updatedAt) : '-' }}</td>
              <td>
                <div class="d-flex align-center">
                  <mf-icon fill small :color="statusColor(item.active)">fiber_manual_record</mf-icon>
                  <span class="ml-2">{{ item.active ? 'Ativo' : 'Inativo' }}</span>
                </div>
              </td>
              <td>
                <div
                  v-if="
                    !isSelect &&
                    ($getLoggedUser().has_club || ($getIsEcommerce() && userPermissions.includes('view_modelo')) || $getLoggedUser().has_mercapromo)
                  "
                  class="d-flex justify-end align-center azul-l40"
                >
                  <mf-tooltip top>
                    <template #activator="{ on }">
                      <mf-button color="cinza-0" type="icon" icon="open_in_new" @click="openProductDetail(item)" />
                    </template>
                    <span>Editar produto</span>
                  </mf-tooltip>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { QUERY_GET_PRODUCTS } from '../../graphql'
import { DateTime } from 'luxon'

export default {
  name: 'GerenciamentoProdutoLojaTabela',
  components: {},
  props: {
    value: {
      type: Object,
      required: false,
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
    },
    filters: {
      type: Object,
      default: () => ({
        departmentId: '',
        categoryId: '',
      }),
    },
  },
  data: () => ({
    paginationLoading: false,
    maxRecords: 1,
    search: '',
    options: {},
    timeout: {},
    products: [],
  }),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    userPermissions() {
      return this.$getLoggedUser().ecommercePermissions
    },
    isPhygital() {
      return this.$getLoggedUser().has_club && this.$getIsEcommerce()
    },
    headers() {
      let headers = [
        {
          text: 'Imagem',
          value: 'images',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'name',
          width: '40%',
          sortable: false,
        },
        {
          text: 'Ean principal',
          value: 'ean',
          width: '20%',
          sortable: false,
        },
        { text: 'SKU', value: 'legacySku', width: '10%', sortable: false },
        {
          text: 'Departamento',
          value: 'department.name',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Plataforma',
          value: 'plataform',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Data criação',
          value: 'createdAt',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Última atualização',
          value: 'updatedAt',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'active',
          width: '10%',
          sortable: false,
        },
        {
          text: '',
          value: '',
          width: '10%',
          sortable: false,
          align: 'right',
        },
      ]

      if (!this.$getLoggedUser().has_club && this.$getIsEcommerce() && !this.$getLoggedUser().has_mercapromo) {
        headers = headers.filter((i) => i.value !== 'legacySku')
      }
      if (!this.isPhygital) {
        headers = headers.filter((i) => i.value !== 'plataform')
      }

      return headers
    },
  },
  watch: {
    options() {
      this.getData()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getLabelPlataform(item) {
      if (item.cbm && item.ecommerce) {
        return 'CBM/E-commerce'
      } else if (item.cbm && !item.ecommerce) {
        return 'CBM'
      } else if (!item.cbm && item.ecommerce) {
        return 'E-commerce'
      }

      return '-'
    },
    formatDate(val) {
      return DateTime.fromISO(val).toFormat('dd/MM/yyyy')
    },
    clearProducts() {
      this.products = []
    },
    filterBySearch(query) {
      clearTimeout(this.timeout)
      this.paginationLoading = true
      this.timeout = setTimeout(() => {
        this.options.page = 1
        this.getData()
      }, 1000)
    },
    async getData() {
      const filters = {
        categoryId: this.filters.categoryId,
        departmentId: this.filters.departmentId,
      }

      if (this.filters.active !== 'Todos') {
        filters.active = this.filters.active
      }

      if (this.filters.withImages !== 'Todos') {
        filters.withImages = this.filters.withImages
      }

      if (this.filters.cbm !== 'Todos') {
        filters.cbm = this.filters.cbm
      }

      if (this.filters.ecommerce !== 'Todos') {
        filters.ecommerce = this.filters.ecommerce
      }

      if (this.$getLoggedUser().has_club && this.$getIsEcommerce() && ['ecommerce', 'cbm'].includes(this.filters.products)) {
        filters.ecommerce = this.filters.products === 'ecommerce'
        filters.cbm = this.filters.products === 'cbm'
      }
      if (this.filters.manuallyEdited !== null) {
        filters.manuallyEdited = this.filters.manuallyEdited
      }
      if (this.filters.typeEan) {
        filters.eanEnum = this.filters.typeEan
      }
      const search = this.search.replace(/"/g, "'")
      try {
        this.paginationLoading = true
        const {
          data: {
            listProduct: { products, records },
          },
        } = await this.$apollo.query({
          query: QUERY_GET_PRODUCTS,
          variables: {
            page: this.options.page || 1,
            pageSize: this.options.itemsPerPage || 15,
            search,
            filter: filters,
          },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })

        if (this.isSelect) {
          this.products = products.map((product) => {
            if (Object.keys(this.productForms).length > 0 && product.id === this.productForms.id) {
              return { isSelected: true, ...product }
            }
            return { isSelected: false, ...product }
          })
        } else {
          this.products = products
        }

        this.maxRecords = records
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar produtos', snackbarColor: 'error' })
      } finally {
        this.paginationLoading = false
      }
    },
    openProductDetail(item) {
      const { id } = item
      this.$router.push({ path: `/produtos/alterar/${id}` })
    },
    showMainEan(eans) {
      const mainEan = eans.find((ean) => ean.isMain)

      if (mainEan) return mainEan.ean

      return ''
    },
    showMainImage(images) {
      return images[0].urlMiniature.length ? images[0].urlMiniature : images[0].url
    },
    statusColor(status) {
      return status ? '#03e36a' : '#F15435'
    },
    productSelected(indexProduct) {
      this.productForms = this.products[indexProduct]

      this.products.forEach((product, index) => {
        if (index !== indexProduct) {
          product.isSelected = false
        } else {
          product.isSelected = true
        }
      })
    },
    clickAction(item, index) {
      if (this.isSelect) {
        this.productSelected(index)

        return
      }

      this.openProductDetail(item)
    },
  },
}
</script>

<style lang="scss" scoped>
.limitText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 100%;
  margin-bottom: 3px;
}

::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 14px;
    line-height: 1;
  }
  td:hover {
    cursor: pointer;
  }
}
.limitText {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  cursor: context-menu;
}
.td-img {
  width: 40px;
  height: 40px;
}
.icon-align {
  padding-left: 8.5px;
}
.icon-color {
  color: $marca-0-l40 !important;
}
.chip-color-catalog {
  background-color: #ccf0d8 !important;
  color: $verde-d20 !important;
}
.chip-color-edit {
  background-color: #f8e2d2 !important;
  color: #86410f !important;
}
.chip-column {
  cursor: pointer;
}
</style>
